import { Mutations } from 'vuex-smart-module';
import ClientsSharedState from './state';

export default class ClientsSharedMutations extends Mutations<ClientsSharedState> {
}
